module.exports = __webpack_public_path__ + "static/img/UPI.f3d2ddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/UPI.png
// module id = DLHT
// module chunks = 0